import type { SortingState } from '@tanstack/table-core'

import type { TableSettingsState } from '@/helpers/cookieStorage/userSettings/tableSettings/shared'

import { TransactionType } from '@/types/legacy'

import type { MarketTransactionType } from '../transactions.contract'

export const PAGE_SIZE = 10

/**
 * Column IDs. `market.transactions` sorts by timestamp DESC only — these are
 * plain identifiers, not tied to a sort order.
 */
export const COLUMN_IDS = {
  Timestamp: 'Timestamp',
  TypeText: 'TypeText',
  AssetsUsd: 'AssetsUsd',
  User: 'User',
  TransactionHash: 'TransactionHash'
} as const

export const MARKET_TRANSACTIONS_INITIAL_SORTING: SortingState = [
  {
    id: COLUMN_IDS.Timestamp,
    desc: true
  }
]

export const MARKET_TRANSACTIONS_DEFAULT_TABLE_SETTINGS: TableSettingsState = {
  columnVisibility: {},
  sorting: MARKET_TRANSACTIONS_INITIAL_SORTING,
  columnFilters: [],
  columnOrder: [],
  // Bumping version to force resetting user settings
  version: 1
}

export const MARKET_TRANSACTIONS_STORAGE_KEY = 'marketTransactionsTable'

export const TRANSACTION_FILTER_OPTIONS = [
  { label: 'Withdraw', value: TransactionType.MarketWithdraw },
  { label: 'Withdraw Collateral', value: TransactionType.MarketWithdrawCollateral },
  { label: 'Lend', value: TransactionType.MarketSupply },
  { label: 'Supply Collateral', value: TransactionType.MarketSupplyCollateral },
  { label: 'Borrow', value: TransactionType.MarketBorrow },
  { label: 'Repay', value: TransactionType.MarketRepay }
]

/**
 * Two-way mapping between the legacy `TransactionType.Market*` enum used by
 * the filter UI and persisted user settings, and the `market.transactions`
 * `type` values.
 */
export const LEGACY_TO_MARKET_TRANSACTION_TYPE: Partial<
  Record<TransactionType, MarketTransactionType>
> = {
  [TransactionType.MarketSupply]: 'supply',
  [TransactionType.MarketWithdraw]: 'withdraw',
  [TransactionType.MarketBorrow]: 'borrow',
  [TransactionType.MarketRepay]: 'repay',
  [TransactionType.MarketSupplyCollateral]: 'supplyCollateral',
  [TransactionType.MarketWithdrawCollateral]: 'withdrawCollateral'
}

export const MARKET_TRANSACTION_TYPE_TO_LEGACY: Record<MarketTransactionType, TransactionType> = {
  supply: TransactionType.MarketSupply,
  withdraw: TransactionType.MarketWithdraw,
  borrow: TransactionType.MarketBorrow,
  repay: TransactionType.MarketRepay,
  supplyCollateral: TransactionType.MarketSupplyCollateral,
  withdrawCollateral: TransactionType.MarketWithdrawCollateral
}

export const MARKET_TRANSACTION_TYPE_LABELS: Record<MarketTransactionType, string> = {
  supply: 'Lend',
  withdraw: 'Withdraw',
  borrow: 'Borrow',
  repay: 'Repay',
  supplyCollateral: 'Supply collateral',
  withdrawCollateral: 'Withdraw collateral'
}
